import { createMuiTheme } from '@material-ui/core/styles';


export const themeGreen = createMuiTheme({
    typography: {
        fontFamily: 'Roboto, Arial',
    },
    palette: {
        common: {
            black: "#000",
            white: "#fff"
        },
        background: {
            paper: "#fff",
            default: "#ededed",
            lightGray: "#fafafa"
            //default: "rgba(250, 250, 250, 1)"
        },
        primary: {
            light: "#4bad3a",
            main: "#007d00",            
            dark: "#004f00",            
        },
        secondary: {
            light: "rgba(82, 111, 214, 1)",
            main: "rgba(5, 73, 164, 1)",            
            dark: "rgba(60, 132, 247, 1)",
        },        
        terceary: {
            light: "#9be7ff",
            main: "#64b5f6",
            dark: "#bb002f",
        },
        sponsored: {
            main: "#3483fa"
        },
        error: {
            light: "#e57373",
            main: "#f44336",
            dark: "#d32f2f",
            contrastText: "#fff"
        },
        text: {
            primary: "rgba(66, 66, 66, 1)",
            icon: "rgba(204, 204, 204, 1)",
            secondary: "#757575",
            disabled: "rgba(189, 189, 189, 1)",
            hint: "rgba(0, 0, 0, 0.38)"
        }
    }
});